<template>
  <div class="teacherLayoutRootBox">
    <div class="header">
      <div class="title">数据统计</div>
      <div>
        <m-selects @change="selectChange"></m-selects>
      </div>
    </div>
    <div class="main">
      <div role="aphorism">
        <m-aphorism></m-aphorism>
      </div>
      <div role="openingStatus">
        <m-opening-status :left-list="openingStatus" :ranking="ranking" :hide-right="true"></m-opening-status>
      </div>
      <div data-title="" role="learningDuration">
        <m-title title-text="课件学习" :tip-text="tipText+'，显示从当前时间往前一周或一个月的数据'"></m-title>
        <div class="learningDuration">
          <m-chart :option-data="learningDurationBrokenLineData" :tip-style="tipStyle"></m-chart>
        </div>
        <div class="timeSwitchBox">
          <m-switch @change="timeSwitchChange"></m-switch>
        </div>
      </div>
      <div data-title="笔记和讨论" role="notesAndDiscussions">
        <div style="height: 55%;width: 80%">
          <m-notes-and-discussions :data-list="notesAndDiscusCounts"></m-notes-and-discussions>
        </div>
      </div>
      <div data-title="测验平均分" role="testProgress">
        <!--        <m-line-progress :progress="testProgress" progressClass="yellow" style="margin-bottom: 50px"></m-line-progress>-->
        <div class="cProgressBox">
          <m-circular-progress :score="testScore"></m-circular-progress>
        </div>
      </div>
      <div data-title="" role="testScore">
        <m-title title-text="测验分数" :tip-text="testTipText"></m-title>
        <div class="learningDuration">
          <m-chart :option-data="testScoreBrokenLineData"></m-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import mixinsData, {getBarData, getLineData} from '../mixins'
import {
  classRanking,
  classStudyCount,
  courseTaskCount,
  examPaperAvgScore,
  examPaperScore,
  myDiscussion,
  myNote,
  noSolveQuestion,
  questionCount,
  studentFindList
} from "@/api/PostUrl";


export default {
  name: "studentLayout",
  mixins: [mixinsData],
  computed: {},
  data() {
    return {
      numberOfProfessionalsBarData: getBarData(['未学人数', '在学人数', '已学人数'], '', '个'),
      learningDurationBrokenLineData: getLineData(['学习时长'], '', '秒'),
      testScoreBrokenLineData: getLineData(['我的分数', '平均分数', '最高分数'], '', '分'),
      courseType: '0',
      ranking: {title: '专业排名', score: '0', totalNum: '0'},
      testProgress: 0,//测验进度
      testScore: 0,//测验平均分数
      classProgress: [0, 0, 0],
      classProgressList: [[], [], []],
      openingStatus: [
        {//班级
          icon: 'curriculum',
          title: '班级',
          content: '0个'
        },
        {//任务
          icon: 'task',
          title: '数字课程任务',
          content: '0个'
        },
        {//实训
          icon: 'training',
          title: '实践教学任务',
          content: '0个'
        },
        //TODO 暂时隐藏
        // {//待解决
        //   icon: 'pending',
        //   title: '问题待解决',
        //   content: '0个',
        //   tip: '在老师答疑区发布的主题数，其他提问方式敬请期待'
        // },
        {//题库数量
          icon: 'quantity',
          title: '题库数量',
          content: '0个'
        }
      ],
      notesAndDiscusCounts: [
        {
          content: '0条',
          describe: '笔记条数'
        },
        {
          content: '0条',
          describe: '发表主题数'
        },
        {
          content: '0条',
          describe: '回复主题数'
        },
        {
          content: '0条',
          describe: '发表评论数'
        },
      ],
      fromData: {}
    }
  },
  methods: {
    selectChange(fromData) {
      this.fromData = fromData
      this.classRanking()
      this.classStudyCount()
      this.courseTaskCount()
      this.questionCount()
      // this.noSolveQuestion()
      this.examPaperAvgScore()
      this.examPaperScore()
      this.myNote()
      this.myDiscussion()
      this.timeSwitchChange(this.currentSwitchTime)
    },
    //查询班级排名
    async classRanking() {
      //TODO 接口没有写好目前为隐藏掉了
      this.ranking.score = 0
      this.ranking.totalNum = 0
    },
    //班级学习统计
    async classStudyCount() {
      const data = await this.$apiPost.httpPostForMap(classStudyCount, this.fromData)
      this.openingStatus[0].content = `进行中${data.doingCount || 0}个` //暂时去掉 已结束${data.completeCount || 0}个
    },
    //任务完成情况(课程和实训)
    async courseTaskCount() {
      const data = await this.$apiPost.httpPostForMap(courseTaskCount, this.fromData)
      this.openingStatus[1].content = `已完成${data.courseTaskCompleteCount || 0}个 / 待完成${data.courseTaskDoingCount || 0}个`
      this.openingStatus[2].content = `已完成${data.trainTaskCompleteCount || 0}个 / 待完成${data.trainTaskDoingCount || 0}个`
    },
    //待解决问题
    async noSolveQuestion() {
      const data = await this.$apiPost.httpPostForMap(noSolveQuestion, this.fromData)
      this.openingStatus[3].content = `${data || 0}个`
    },
    //题库数量
    async questionCount() {
      questionCount.params.courseId = this.fromData.courseId
      const data = await this.$apiPost.httpPostForMap(questionCount)
      this.openingStatus[3].content = `${data || 0}个`
    },
    //测验平均分
    async examPaperAvgScore() {
      const data = await this.$apiPost.httpPostForMap(examPaperAvgScore, this.fromData)
      this.testScore = data || 0
    },
    //测验平均分
    async examPaperScore() {
      const data = await this.$apiPost.httpPostForMap(examPaperScore, this.fromData)
      this.setTestScoreBrokenLineData(data || [])
    },
    //设置测验分数分布范围配置
    setTestScoreBrokenLineData(data = []) {
      this.testScoreBrokenLineData.xAxis.data = data.map(item => item.examName)
      let maxScore = null
      if (data.length) {
        maxScore = Math.max.apply(null,data.map(item => item.maxScore))
      }
      this.setFractionYAxisMax(this.testScoreBrokenLineData,maxScore)
      const keys = ['myScore', 'avgScore', 'maxScore']
      keys.forEach((key, index) => this.testScoreBrokenLineData.series[index].data = data.map(item => item[key] > 0 ? item[key] : 0))
      this.testScoreBrokenLineData.additionalInfo = {
        title: '所在目录',
        values: data,
        key: 'lastCatalogName'
      }
    },
    //公开笔记数
    async myNote() {
      const data = await this.$apiPost.httpPostForMap(myNote, this.fromData)
      this.notesAndDiscusCounts[0].content = `${data || 0}条`
    },
    //讨论
    async myDiscussion() {
      const data = await this.$apiPost.httpPostForMap(myDiscussion, this.fromData)
      this.notesAndDiscusCounts[1].content = `${data.publishThemeCount || 0}条`
      this.notesAndDiscusCounts[2].content = `${data.replyThemeCount || 0}条`
      this.notesAndDiscusCounts[3].content = `${data.publishDiscussCount || 0}条`
    },
    //学生课件学习时长
    async studentFindList(startDate, endDate) {
      Object.assign(studentFindList.params, this.fromData)
      if (startDate && endDate) {
        studentFindList.params.startDate = startDate
        studentFindList.params.endDate = endDate
      }
      const data = await this.$apiPost.httpPostForMap(studentFindList,)
      this.setLearningDurationBrokenLineData(data)
    },
    setLearningDurationBrokenLineData(data = []) {
      this.learningDurationBrokenLineData.xAxis.data = data.map(item => item.studyDate)
      const keys = ['myTime']
      keys.forEach((key, index) => this.learningDurationBrokenLineData.series[index].data = data.map(item => item[key] > 0 ? item[key] : 0))
    },
    async timeSwitchChange(item) {
      await this.weekMonthChange(item, this.studentFindList)
    },
  },
}
</script>

<style lang="scss" scoped>
.teacherLayoutRootBox {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  & > .header {
    position: sticky;
    top: 0;
    z-index: 99;
    width: 100%;
    height: 56px;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0 0 0 4px;
    box-shadow: -2px 2px 10px #f0f0f3;

    & > .title {
      font-size: 20px;
      font-weight: bold;
      margin-left: 20px;
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      width: 4px;
      height: 24px;
      border-radius: 0 4px 4px 0;
      background-color: #5397F7;
    }
  }

  & > .main {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: calc(0.12 * var(--fontSize));
    padding: 0 40px 0 0;
    box-sizing: border-box;
    margin-top: calc(0.12 * var(--fontSize));

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      background-color: white;
      position: relative;
    }

    & > div:before {
      content: attr(data-title);
      position: absolute;
      left: calc(0.3 * var(--fontSize));
      top: calc(0.23 * var(--fontSize));
      font-size: calc(0.18 * var(--fontSize));
    }

    & > div[role=aphorism] {
      grid-column: 1 / span 3;
      //height: calc(0.73 * var(--fontSize));
    }


    & > div[role=openingStatus] {
      grid-column: 1 / span 3;
      height: calc(1.1 * var(--fontSize));
      background-color: transparent;
    }


    & > div[role=learningDuration] {
      grid-column: 1 / span 2;
      height: calc(3.88 * var(--fontSize));
      min-height: 388px;
      position: relative;

      .learningDuration {
        width: 100%;
        height: 100%;
      }

      .timeSwitchBox {
        position: absolute;
        z-index: 8;
        top: 12%;
        right: 6%;
      }
    }


    & > div[role=testProgress] {
      height: calc(4.60 * var(--fontSize));
      min-height: 460px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .cProgressBox {
        width: calc(2.1 * var(--fontSize));
        height: calc(2.1 * var(--fontSize));
      }
    }

    & > div[role=testScore] {
      grid-column: 2 / span 2;

      & > .learningDuration {
        width: 90%;
        height: 100%;
        position: relative;

        & > .selector {
          width: calc(2.8 * var(--fontSize));
          height: calc(0.36 * var(--fontSize));
          position: absolute;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          right: 5%;
          top: 7%;

          & > div.content-box {
            height: 100%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            z-index: 9;
            border-radius: 8px;
            background: linear-gradient(180deg, rgba(243, 245, 247, 1) 0%, rgba(243, 245, 247, 1) 9.91%, rgba(242, 245, 247, 1) 100%);
            border: 1px solid rgba(255, 255, 255, 1);
            box-shadow: inset -6px -6px 15px 0px rgba(255, 255, 255, 1), inset 4px 4px 13px 0px rgba(222, 221, 227, 0.28);
            padding: 0 10px;
            box-sizing: border-box;

            & > .arrow {
              width: 8px;
              height: 8px;
              border-radius: 2px;
              border-top: 2px solid rgba(151, 151, 151, 1);
              border-right: 2px solid rgba(151, 151, 151, 1);
              transform: rotate(135deg);
            }
          }
        }
      }
    }

    & > div[role=notesAndDiscussions] {
      height: calc(3.88 * var(--fontSize));
      min-height: 388px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/layout/studentLayout.vue